import GeneratedProjectServiceApi from "./generated/GeneratedProjectServiceApi"

class ProjectServiceApi extends GeneratedProjectServiceApi {

}

export const projectServiceApi = new ProjectServiceApi()
